import { useState } from "react";
import Svg from "../components/atoms/Svg";

const usePasswordToggle = () => {
  // Domyślnie hasło jest ukryte
  const [visible, setVisibility] = useState(false);

  // Jeżeli visible === true, to typ inputu to "text" (pokazuje hasło)
  const InputType = visible ? "text" : "password";

  // Odwracamy logikę ikon:
  // Jeżeli hasło jest niewidoczne (visible === false) -> wyświetlamy przekreślone oko
  // Jeżeli hasło jest widoczne (visible === true) -> zwykłe oko
  const Icon = (
    <button
      type="button"
      onClick={() => setVisibility((prev) => !prev)}
      className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors duration-300"
    >
      <Svg
        src={!visible ? "/icons/eye-slash.svg" : "/icons/eye.svg"}
        className="w-5 h-5"
      />
    </button>
  );

  return [InputType, Icon];
};

export default usePasswordToggle;
